module.exports = __webpack_public_path__ + "img/cam.2ab4e96f.svg";